<template>
  <a v-if="showLink && href" :href="href" class="btn-link" v-bind="customBindings">
    <slot></slot>
  </a>
  <component :is="tag" v-else>
    <slot></slot>
  </component>
</template>

<script lang="ts">
  import Vue from "vue";
  import componentTagMixin from '~/mixins/componentTagMixin'

  export default Vue.extend({
    mixins: [
      componentTagMixin({default: 'div'}),
    ],
    props: {
      href: {
        type: String,
        default: null,
      },
      showLink: {
        type: Boolean,
        default: true,
      },
      newTab: {
        type: Boolean,
        default: false,
      }
    },
    data: function() {
      return {};
    },
    computed: {
      customBindings() {
        const attrs: {target?: string} = {}
        if (this.newTab) attrs.target = '_blank'
        return attrs
      }
    },
  });
</script>
